import {
  Component,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter
} from '@angular/core';

import { EventsService } from '../../services/event.service'
import { ColorUtils } from "../../style/color/utils/color.utils.class"
import { UIColorModel } from '../../services/ui.color.model.service';
import { TabsSet } from '../../classes/navigation/tabs.class';

@Component({
  selector: 'tabs-m3',
  inputs: ['data'],
  outputs: ['clicked', 'direction', 'cssclass'],
  changeDetection: ChangeDetectionStrategy.Default,

  template: `
        <ul class="_tabs-container-m3" surfaceColor>
            <div class="item {{this.activeClass(dat.isActive)}}"
              [style.borderBottom]=this.activeBorder(dat.isActive)
              *ngFor="let dat of this._data.tabs" 
              (click)=tabClicked(dat.id)>
                <div class="label">{{dat.label}}</div>
            </div>
        </ul>

  `,
})
export class TabsM3Component {
  @Output()
  clicked = new EventEmitter();
  direction = new EventEmitter();
  cssclass = new EventEmitter();

  @Input()
  set data(value: TabsSet) {
    this.setData(value);
  }

	private changeDetectorRef: ChangeDetectorRef
	private eventsService: EventsService
  private colorUtils: ColorUtils = new ColorUtils()
	uiColorModel: UIColorModel

  _data: TabsSet = new TabsSet()

	constructor(public ref: ChangeDetectorRef, private _eventsService: EventsService,
		private _uiColorModel: UIColorModel) {
		this.changeDetectorRef = ref
		this.eventsService = _eventsService
		this.uiColorModel = _uiColorModel
	}

  setData(value: TabsSet) {
    this._data = value
  }

  ngOnInit() {}

  ngOnChanges() {}

  ngOnDestroy() {}


  tabClicked(id: string) {
    this._data.setActive(id, true)
  }

  activeClass(isActive: boolean): string {
    let result = ""
    if(isActive) {
      result = "active"
    } else {
      result = ""
    }
    return result
  }

  activeBorder(isActive: boolean): string {
    let result = ""
    if(isActive) {
      result = "solid 2px " + this.uiColorModel.primary
    } else {
      result = "none"
    }
    return result
  }


}
